import React from 'react';
import { getConfiguration, getFormattedTimestamp, getCurrencyValue} from '../../utils';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import { getLabel } from '../../../InitData';


function CashoutReceipt(props) {
	const conf = getConfiguration();
	
	const additionalStyle = {
			"fontFamily" : "sans-serif",
			"fontSize" : "19px"
	};

	
	const opData = props.data;
	const operationTitle = getLabel('cashout.translation');
	const formattedTimestamp =  getFormattedTimestamp();
	const amountWithCurrency =  getCurrencyValue(opData.cashoutAmount, conf.cs.m, conf.cs.nd, conf.cs.ct);
	const terminalBalance = getCurrencyValue(opData.terminalBalance, conf.cs.m, conf.cs.nd, conf.cs.ct);	
	return (
		<body style={additionalStyle}>

			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={operationTitle}></ShopReceiptHeader>
			
			<div>{getLabel('retail.date_time') + ": " + formattedTimestamp}</div>
			<div>{getLabel('retail.amount') + ": " + amountWithCurrency}</div>
			<div>{getLabel('retail.shop_pvend') + ": " + opData.shopId}</div>
			<div>{getLabel('retail.terminal_number') + ": " + opData.idTag}</div>
			{
				opData.showTerminalBalance && <div>{getLabel('retail.terminal_balance') + ": " + terminalBalance}</div>
			}
			<div>{getLabel('retail.terminal_number') + ": " + opData.idTag}</div>
			{ 
				opData.showOperatorName && <div>{getLabel('retail.operator') + ": " + opData.operatorUsername}</div>
			}
			<hr className="hr-line" />
			{
				<div className="centerText">{opData.ticketId}</div>
			}

			
			<ShopReceiptFooter></ShopReceiptFooter>
		</body>
    );
}

export default CashoutReceipt;